import Colors from 'components/Colors.js';

const colors = new Colors();
window.groupOpacity = 0.5;

export const useGroupStyle = ({pos, group, selectedPianoRollSteps}) => {
    let style = {};
    if (pos) {
        let {x,y,height,width} = pos;
        style = {
            left: x,
            top: y - 5,
            height,
            width,
            backgroundColor: colors.transparent(colors.saturate(colors.getColorForHash(group.id), 1.1), window.groupOpacity)
        };
    }

    if (style.left === undefined) {
        style.height = 0;
    }

    let selected =  (selectedPianoRollSteps && selectedPianoRollSteps.some(
        x => x.group === group));

    let className = "steps-group";
    if (selected) {
        className += " selected";
    }



    return {style, selected, className};
};
